const periodontology = {
  hero: {
    topLine: "Gum Health Specialists",
    titleLine1: "Advanced Periodontology",
    titleLine2: "For Healthy Gums",
    description:
      "Our specialized periodontal treatments address gum disease and promote oral health with advanced, minimally invasive techniques.",
    ctas: {
      primary: "Book Consultation",
      secondary: "Learn More",
    },
    imageAlt: "Advanced Periodontal Treatment",
    stats: {
      value: "98%",
      label: "Success Rate",
    },
    floatingLabel: "Gum Restoration",
  },
  benefits: {
    heading: "WHY CHOOSE OUR PERIODONTAL CARE",
    intro:
      "Experience comprehensive periodontal treatments with a focus on prevention and long-term gum health.",
    items: [
      {
        title: "Gum Disease Prevention",
        description:
          "Our treatments help prevent and manage periodontitis, protecting your teeth from loss and preserving your smile.",
      },
      {
        title: "Improved Overall Health",
        description:
          "Healthy gums contribute to better overall health by reducing inflammation and bacterial infection risks.",
      },
      {
        title: "Early Detection",
        description:
          "We identify and address periodontal issues early, preventing progression to more severe conditions.",
      },
    ],
  },
  process: {
    heading: "OUR PERIODONTAL TREATMENT PROCESS",
    intro:
      "A systematic approach to diagnosing and treating periodontal conditions for optimal gum health",
    stepLabel: "Step",
    items: [
      {
        title: "Comprehensive Assessment",
        description:
          "Thorough examination of your gums, measuring pocket depths and checking for inflammation and bleeding.",
      },
      {
        title: "Diagnosis & Planning",
        description:
          "Detailed diagnosis of your periodontal condition and creation of a personalized treatment plan.",
      },
      {
        title: "Specialized Treatment",
        description:
          "Advanced periodontal therapies including scaling, root planing, and laser treatments when needed.",
      },
      {
        title: "Maintenance & Follow-up",
        description:
          "Regular check-ups and maintenance to ensure long-term health of your gums and prevent recurrence.",
      },
    ],
  },
  faq: {
    heading: "FREQUENTLY ASKED QUESTIONS",
    intro:
      "Get answers to common questions about periodontal health and treatments",
    items: [
      {
        question: "What is periodontal disease?",
        answer:
          "Periodontal disease, commonly known as gum disease, is an infection of the tissues that hold your teeth in place. It's typically caused by poor brushing and flossing habits that allow plaque—a sticky film of bacteria—to build up on the teeth and harden.",
      },
      {
        question: "What are the signs of gum disease?",
        answer:
          "Common signs include red, swollen, or tender gums, bleeding while brushing or flossing, receding gums, persistent bad breath, loose teeth, and changes in how your teeth fit together when you bite.",
      },
      {
        question: "Is periodontal treatment painful?",
        answer:
          "Most periodontal treatments are performed with local anesthesia, ensuring your comfort. For more extensive procedures, sedation options are available. Post-treatment discomfort is usually minimal and can be managed with over-the-counter pain relievers.",
      },
      {
        question: "How long does periodontal treatment take?",
        answer:
          "The duration depends on the severity of your condition. Initial treatments might require 1-2 appointments, while more advanced cases may need several visits over weeks or months. Maintenance visits are typically scheduled every 3-4 months.",
      },
      {
        question: "Can gum disease be reversed?",
        answer:
          "Early gum disease (gingivitis) can be reversed with professional treatment and good oral hygiene. Advanced periodontal disease cannot be completely reversed, but it can be effectively managed to prevent progression and save affected teeth.",
      },
      {
        question: "Is periodontal disease linked to other health conditions?",
        answer:
          "Yes, research has shown connections between periodontal disease and several systemic conditions including heart disease, diabetes, respiratory diseases, and certain pregnancy complications. Maintaining healthy gums contributes to your overall well-being.",
      },
    ],
  },
};

export default periodontology;

